import { useMeasurementRequest } from "@/hooks/useMeasurementRequests";
import {
  ModalContentEmpty,
  ModalContentError,
  ModalContentLoading,
} from "@/components/shared/Modal";
import {
  SharedMeasurementRequestDialogProps,
  UpdateMeasurementRequestDialog,
} from "@/components/measurementRequests/MeasurementRequestDialog";

export const UpdateMeasurementRequestDialogWrapper = ({
  measurementRequestId,
  ...rest
}: { measurementRequestId: number } & SharedMeasurementRequestDialogProps) => {
  const { data, error, isLoading } = useMeasurementRequest(measurementRequestId);

  if (isLoading)
    return (
      <ModalContentLoading
        className="max-h-[90vh] md:max-w-[80%] overflow-y-auto lg:w-[90%] lg:max-w-[1400px] mx-auto"
        description="Loading modal content..."
        title="Loading MeasurementRequest details..."
        onOpenChange={rest.onOpenChange}
      />
    );

  if (error) {
    return (
      <ModalContentError
        className="max-h-[90vh] md:max-w-[80%] overflow-y-auto lg:w-[90%] lg:max-w-[1400px] mx-auto"
        description={error.message}
        onOpenChange={rest.onOpenChange}
      />
    );
  }

  if (!data)
    return (
      <ModalContentEmpty
        className="max-h-[90vh] md:max-w-[80%] overflow-y-auto lg:w-[90%] lg:max-w-[1400px] mx-auto"
        onOpenChange={rest.onOpenChange}
      />
    );

  return <UpdateMeasurementRequestDialog {...rest} measurementRequest={data} />;
};
